var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:edit-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.249 5.62982L8.25286 13.626L5.07094 14.184C5.05055 14.1869 5.03911 14.1875 5.0332 14.1875C4.99732 14.1875 4.95878 14.1754 4.91842 14.1371C4.90139 14.1198 4.8887 14.0986 4.88138 14.0754L4.40454 14.2258L4.88138 14.0754C4.87384 14.0515 4.87224 14.0261 4.87673 14.0014L4.87725 13.9985L5.43653 10.8096L13.4335 2.81264L16.249 5.62982ZM16.4647 5.84564C16.4647 5.84561 16.4646 5.84558 16.4646 5.84555L16.4647 5.84564ZM5.9961 10.9276L5.88439 11.0393L5.85712 11.1949L5.55243 12.9332L5.42924 13.636L6.13188 13.5119L7.86821 13.2053L8.02334 13.1779L8.13475 13.0665L15.2187 5.98446L15.5724 5.63091L15.2188 5.27731L13.7871 3.84567L13.4336 3.49216L13.0801 3.84562L5.9961 10.9276ZM2.8125 16.8281H17.1875C17.2571 16.8281 17.3125 16.8836 17.3125 16.9531V17.3125H2.6875V16.9531C2.6875 16.8836 2.74294 16.8281 2.8125 16.8281Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.bb8fb5cb64f486a500dfd602eb706189.svg";
export { ForwardRef as ReactComponent };